import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

// AI 动作定义
const aiActions = defineAIActions({
  namespace: 'track',
  actions: [
    {
      id: 'analyze',
      name: '分析赛道',
      description: '深度分析赛道竞争格局和机会',
      parameters: [
        { name: 'trackId', type: 'number', description: '赛道ID', required: true },
      ],
      handler: async (params) => {
        const response = await fetch(`/api/v1/tracks/${params.trackId}/analyze`);
        const data = await response.json();
        return {
          type: 'report',
          data: data.data,
          message: '赛道分析完成',
        };
      },
    },
    {
      id: 'suggest-keywords',
      name: '推荐关键词',
      description: '根据赛道推荐热门关键词',
      parameters: [
        { name: 'trackId', type: 'number', description: '赛道ID', required: true },
        { name: 'count', type: 'number', description: '推荐数量', required: false },
      ],
      handler: async (params) => {
        const response = await fetch(`/api/v1/tracks/${params.trackId}/keywords?pageSize=${params.count || 10}`);
        const data = await response.json();
        return {
          type: 'table',
          data: data.data?.items || [],
          message: `推荐了 ${data.data?.items?.length || 0} 个关键词`,
        };
      },
    },
    {
      id: 'predict-trends',
      name: '趋势预测',
      description: '预测赛道内容趋势',
      parameters: [
        { name: 'trackId', type: 'number', description: '赛道ID', required: true },
      ],
      handler: async (params) => {
        const response = await fetch(`/api/v1/tracks/${params.trackId}/analyze`);
        const data = await response.json();
        return {
          type: 'report',
          data: {
            ...data.data,
            type: 'trend-prediction',
          },
          message: '趋势预测完成',
        };
      },
    },
  ],
});

// 导出插件定义
export default definePlugin({
  meta: {
    name: 'track-manager',
    version: '1.0.0',
    displayName: '赛道管理',
    description: '多赛道规划、关键词库、热点追踪',
    icon: 'target',
    category: 'core',
  },

  // 生命周期钩子
  onLoad: async () => {
    console.log('[Plugin] Track Manager loaded');
  },

  onUnload: () => {
    console.log('[Plugin] Track Manager unloaded');
  },

  // 路由配置
  routes: [
    {
      path: '/tracks',
      lazy: async () => {
        const { TrackList } = await import('./pages/TrackList');
        return { Component: TrackList };
      },
    },
    {
      path: '/tracks/new',
      lazy: async () => {
        const { TrackEditor } = await import('./pages/TrackEditor');
        return { Component: TrackEditor };
      },
    },
    {
      path: '/tracks/trends',
      lazy: async () => {
        const { TrendAnalysis } = await import('./pages/TrendAnalysis');
        return { Component: TrendAnalysis };
      },
    },
    {
      path: '/tracks/:id',
      lazy: async () => {
        const { TrackDetail } = await import('./pages/TrackDetail');
        return { Component: TrackDetail };
      },
    },
    {
      path: '/tracks/:id/edit',
      lazy: async () => {
        const { TrackEditor } = await import('./pages/TrackEditor');
        return { Component: TrackEditor };
      },
    },
    {
      path: '/tracks/:id/keywords',
      lazy: async () => {
        const { KeywordLibrary } = await import('./pages/KeywordLibrary');
        return { Component: KeywordLibrary };
      },
    },
  ],

  // 侧边栏菜单
  sidebarMenus: [
    {
      id: 'tracks',
      title: '赛道管理',
      icon: 'target',
      path: '/tracks',
      order: 3,
    },
  ],

  // AI 动作
  aiActions,
});

